export default {
    /**
     * @function quickSort 快速排序
     * @param { Array } arr 需要排序的数组
     */
    quickSort(arr: Array<any>): any {
        // 数组长度小于等于1时，停止递归
        if(arr.length <= 1) {
            return arr;
        }
        let left = [], right = [], flag = arr.shift();
        for(let i = 0; i < arr.length; i++) {
            if(flag > arr[i]) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }
        return [...this.quickSort(left), flag, ...this.quickSort(right)];
    },
    /**
     * @function getRandom 获取[n, m]区间的随机整数
     * @param {*} num1 
     * @param {*} num2 
     */
    getRandom(num1: any, num2: any){
        switch(arguments.length){
            case 1:
                return Math.floor(Math.random()*arguments[0]+1); //返回0-max的随机整数
            case 2:
                var min = arguments[0],
                    max = arguments[1];
                if(arguments[0]-arguments[1]>0){
                    min = arguments[1];
                    max = arguments[0];
                }
                return Math.floor(Math.random()*(max-min+1) + min); //返回min-max的随机整数
            default: return 0;
        }
    },
    /**
     * @function jointPicUrl 拼接图片路径
     * @param { string } url 
     */
    jointPicUrl(url: string) {
        if(!url) { return '' }
        if(String(url).slice(0, 4) != 'http') {
            return 'https://admin.p2ipo.com/' + url;
        }
        return url;
    },
    /**
     * @function transformTime 转换时间
     * @param { string } t 需要转换的时间
     * @param {*} iss 是否需要"秒"
     */
    transformTime(t: string, iss: any) {
        let date = new Date(t);
        let y = date.getFullYear(), 
            m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1, 
            d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
            h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(), 
            f = date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes(), 
            s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let time = iss ? `${y}-${m}-${d} ${h}:${f}:${s}` : `${y}-${m}-${d} ${h}:${f}`;
        return time;
    },
    /**
     * @function beforeAvatarUpload 图片上传格式大小判断
     */
    beforeAvatarUpload(file: any) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
            // _this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
            // _this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function beforeVideoUpload 视频上传格式大小判断
     */
    beforeVideoUpload(file: any) {
        let type_list = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'];
        const isJPG = type_list.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 500;
        if (!isJPG) {
            // _this.$message.error('上传的视频只能是 MP4/OGG/AVI 格式!');
        }
        if (!isLt2M) {
            // _this.$message.error('上传的视频大小不能超过 100MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function getScaleStr 获取企业规模中文值
     * @param scale 
     */
    getScaleStr(scale: string) {
        if(!scale) { return '' }
        switch (scale) {
            case '1':
                return '双创板（100万＜规模范围≤500万）';
            case '2':
                return '加速板（500万＜规模范围≤2000万）';
            case '3':
                return '规上板（2000万＜规模范围≤1亿）';
            case '4':
                return '红筹板（1亿以上）';
            case '5':
                return '股改板';
            default:
                return '';
        }
    },
    /**
     * @function numberToString 数字转中文（限0-10）
     * @param num 数字
     */
    numberToString(num: number) {
        if(num < 0 || num > 10) { return ''; }
        let strList: Array<string> = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
        return strList[num];
    },
    /**
     * @function getResearchTypeStr 获取产业研究类型值
     * @param type 类型
     */
    getResearchTypeStr(type: string) {
        switch (Number(type)) {
            case 0:
                return '白皮书';
            case 1:
                return '行业研究报告';
            case 2:
                return '统计数据';
            case 3:
                return '论文';
            case 4:
                return '专利';
            default:
                return '';
        }
    }
}